// extracted by mini-css-extract-plugin
export default {"h2":"Summary_h2__D9-ch"};